import { connect, ConnectedProps } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { RootState } from '../../../store';
import * as Actions from '../actions';
import RegisterComponent from '../components/RegisterComponent';
import { ICompanyState, ICreateCompany } from '../reducers';

const mapStateToProps = (state: RootState) => {
  return {
    token: state.authReducer.token,
    isLogged: state.authReducer.isLogged,
    user: state.authReducer.user
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    register: (email: string, password: string, phone: string, name: string, firstname: string) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(Actions.register(email, password, phone, name, firstname, resolve, reject));
      });
    },
    getCompanyInfos: (company: string) => {
      return new Promise((resolve: (companyInfos: ICompanyState) => void, reject: any) => {
        dispatch(Actions.getCompanyInfos(resolve, reject, company));
      });
    },
    verifyPhoneNumber: (smsCode: string) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(Actions.verifyPhoneNumber(smsCode, resolve, reject));
      });
    },
    verifyIfSubDomainDoesExist: (subDomain: string) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(Actions.verifyIfSubDomainDoesExist(subDomain, resolve, reject));
      });
    },
    emailExists: (email: string) => {
      return new Promise((resolve: (exists: boolean) => void, reject: any) => {
        dispatch(Actions.emailExists(resolve, reject, email));
      });
    },
    companyExists: (siren: string) => {
      return new Promise((resolve: (exists: boolean) => void, reject: any) => {
        dispatch(Actions.companyExists(resolve, reject, siren));
      });
    },
    createCompany: (infos: ICreateCompany) => {
      return new Promise((resolve: (companyID: string) => void, reject: any) => {
        dispatch(Actions.createCompany(resolve, reject, infos));
      });
    },
    setIsLogged: (value: boolean) => {
      dispatch(Actions.setIsLogged(value));
    }
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromReduxRegister = ConnectedProps<typeof connector>;

export default withRouter(connector(RegisterComponent));
